import React, {Component} from 'react';
import { Form, Icon, Input, Button } from 'antd';
import { loginScreen as strings } from 'ui/constants/strings';

class LoginForm extends Component {
  handleSubmit = e => {
    const { onLogin } = this.props;
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        onLogin(values)
      }
    });
  };

  render() {
    const { form, isLoading } = this.props;
    const { getFieldDecorator } = form;
    return (
      <Form onSubmit={this.handleSubmit} className='login-form'>
        <Form.Item>
          {getFieldDecorator('username', {
            rules: [{ required: true, message: strings.usernameMissing }],
          })(
            <Input
              prefix={<Icon type='user' style={{ color: 'rgba(0,0,0,.25)' }} />}
              placeholder={strings.usernamePlaceholder}
              className='loginInput'
            />,
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator('password', {
            rules: [{ required: true, message: strings.passwordMissing }],
          })(
            <Input
              prefix={<Icon type='lock' style={{ color: 'rgba(0,0,0,.25)' }} />}
              type='password'
              placeholder={strings.passwordPlaceholder}
              className='loginInput'
            />,
          )}
        </Form.Item>
        <Form.Item>
          <Button type='primary' htmlType='submit' className='login-form-button' loading={isLoading}>
            Log in
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

export default Form.create({ name: 'normal_login' })(LoginForm);
